import React from 'react'
import { NavigationActions } from 'react-navigation'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  user: state.user
})

class EmptyScreenX extends React.Component {
  static navigationOptions = {
    title: 'Hello'
  }
  componentWillMount() {
    const { user } = this.props
    if (!user.hasSchool) this.openWelcome()
    else if (!user.hasField) this.openWelcome()
    else this.openHome()
  }
  openHome() {
    this.reset('Tabs')
  }
  openWelcome() {
    this.reset('Welcome')
  }
  openFieldSelect() {
    this.reset('ChooseField')
  }
  reset(routeName) {
    const resetAction = NavigationActions.reset({
      index: 0,
      actions: [NavigationActions.navigate({ routeName })]
    })
    this.props.navigation.dispatch(resetAction)
  }
  render() {
    return null
  }
}

const EmptyScreen = connect(mapStateToProps)(EmptyScreenX)

export { EmptyScreen }



// WEBPACK FOOTER //
// ./src/screens/EmptyScreen.js